<template>
  <div>
    <p v-if="total === 0">Nenhum registro encontrado</p>
    <div class="table-responsive" v-else>
      <table class="table">
        <!--
        <div class="validation-count">
          <div >{{ total }} {{ total > 1 ? 'resultados' : 'resultado' }}</div>
          <div v-if="this.validations">
            <b-form-checkbox
              id="checkbox-serviceStatus"
              v-model="serviceStatus"
              @change="serviceStatusSelected"
            >
              Desabilitar <b-badge pill variant="warning">link criado</b-badge>
            </b-form-checkbox>
          </div>
        </div>
        -->
        <thead class="thead-light">
          <tr>
            <th  class="text-right">
              Data
            </th>
            <th >
            </th>
            <th >
              Cliente
            </th>
            <th >
              Email
            </th>
            <th >
              Telefone
            </th>
            <th >
              Loja
            </th>
            <th >
              Status
            </th>
            <th >
            </th>
          </tr>
        </thead>
        <tbody>
        <tr v-for="tx in txs.list" v-bind:key="tx.id">
          <th scope="row">
            <div>
              <router-link :to="{name: 'OrderValidation', params: { txid: tx.uuid }}"><strong>#{{ tx.id | numeral('00000') }}</strong></router-link>
              <!-- <router-link v-else :to="{name: 'CustomerServiceDetailsNew', params: { txid: tx.uuid }}"><strong>#{{ tx.id | numeral('00000') }}</strong></router-link> -->
            </div>
          </th>
          <td>
            <div >{{tx.dateCreated | moment}} - {{tx.dateCreated | moment-hour}}</div>
          </td>
          <td>
            <div>
              <div ><strong>{{tx.buyerName}} <b-badge pill :variant="(tx.rating === 'A' || tx.rating === 'B') ? 'success' : ((tx.rating === 'D' || tx.rating === 'E') ? 'danger' : 'warning')">{{ tx.rating }}</b-badge></strong></div>
            </div>
          </td>
          <td>
            <div >{{ tx.buyerEmail }}</div>
          </td>
          <td>
            <div >{{ tx.buyerPhone }}</div>
          </td>
          <td>
            <div ><strong>{{ tx.sellerName }}</strong></div>
          </td>
          <td>
            <div >
              <template v-if="tx.installment">
                <div class="pix-container">
                  <span v-if="new Date() < new Date(tx.installment.pixDateExpire)" class="waiting-pix">Aguardando PIX</span>
                  <span v-else class="expired-pix">PIX expirado</span>
                  <div  class="waiting-pix-time">
                    <span v-if="new Date() < new Date(tx.installment.pixDateExpire)">Expira às</span>
                    <span v-if="tx.installment.pix" >{{ checkExpiredTimer(tx.installment.pixDateExpire) }}</span>
                  </div>
                </div>
              </template>
              <!-- <template v-else-if="tx.firstPaymentRequired">
                  <div class="pix-container">
                    <span v-if="tx.firstPaymentDateExpiry" class="waiting-pix">Aguardando PIX</span>
                    <span v-if="tx.firstPaymentDateExpiry" class="waiting-pix-time">{{ pixCodeTimeExpiresCountdown(tx.firstPaymentDateExpiry) }}</span>
                  </div>
              </template> -->
              <b-badge v-else-if="tx.serviceStatus" pill :variant="(tx.serviceStatus === 'Link criado') ? 'warning' : ((tx.serviceStatus === 'Documentos enviados') ? 'success' : (tx.serviceStatus === 'Resposta cliente') ? 'danger' : 'info')">
                {{ tx.serviceStatus }}
              </b-badge>
              <strong v-else>{{ tx.currentStep }}</strong>
            </div>
          </td>
          <td>
            <button class="btn bf-btn-whatsapp" @click="showWhatsappScreen(tx)">
              <i class="fa fa-whatsapp" style="margin: 0; color: #FFF;"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <!-- <b-pagination size="md" align="center" :total-rows="total" v-model="currentPage" :per-page="max" @change="fetchCustomerData"></b-pagination> -->
    <div class="text-center" v-if="total > 9 && max < total">
      <button class="btn bf-btn-loadmore" @click="handleLoadMore()">
        {{ loading ? 'Carregando...' : 'Carregar mais' }}
      </button>
    </div>
  </div>
</template>

<script>
import Button from '../button/Button.vue'
import Input from '../form/Input.vue'
import moment from 'moment-timezone'

export default {
  props: {
    'validations': {
      default: true
    },
    typeList: {
      type: String
    }
  },
  components: {
    'input-component': Input,
    'button-component': Button
  },
  data () {
    return {
      txs: [],
      currentPage: 1,
      max: 10,
      total: 0,
      loading: false,
      openScreen: false,
      phoneNumber: null,
      name: '',
      seller: null,
      serviceStatus: false,
      orderList: null,
      stepList: null,
      date: null,
      textDay: null,
      textHour: '00',
      textMinute: '00',
      textSecond: '00',
      clearPixCount: null,
      pixExpired: false
    }
  },
  destroyed () {
    clearInterval(this.clearPixCount)
    this.txs = []
  },
  mounted () {
    // this.clearPixCount = setInterval(() => {
    //   this.pixCodeTimeExpiresCountdown()
    // }, 1000)

    this.getPixList(1)
  },
  methods: {
    checkExpiredTimer (timer) {
      if (new Date() > new Date(timer)) {
        this.pixExpired = true
      } else {
        return moment(timer).format('HH:mm')
      }
    },
    showWhatsappScreen (lineInfo) {
      this.$emit('uuid', lineInfo.uuid)
      this.$emit('buyerPhone', lineInfo.buyerPhone)
      this.$emit('whatsappOpen', true)
      this.$emit('customerName', lineInfo.buyerName)
      this.$emit('customerProfilePicture', lineInfo.profilePicture)
      this.$emit('seller', lineInfo.sellerName)
      this.$emit('reference', lineInfo.installment)
    },
    handleLoadMore () {
      this.loading = true
      this.max += 10
      this.getPixList()
    },
    pixCodeTimeExpiresCountdown (dateExpire) {
      var strTime = ''
      if (new Date() > new Date(dateExpire)) {
        strTime = '00:00:00'
        return strTime
      }
      const dtExp = new Date(dateExpire)
      const countDate = dtExp.getTime()
      const now = new Date().getTime()
      const gap = countDate - now

      const second = 1000
      const minute = second * 60
      const hour = minute * 60
      const day = hour * 24

      this.textDay = Math.floor(gap / day)
      this.textHour = Math.floor((gap % day) / hour)
      this.textMinute = Math.floor((gap % hour) / minute)
      this.textSecond = Math.floor((gap % minute) / second)

      // if (this.textDay > 0) {
      //   if (strTime !== '') strTime += ', '
      //   strTime += (this.textDay > 1) ? this.textDay + ' dias' : '1 dia'
      // }
      // if (this.textHour > 0) {
      //   if (strTime !== '') strTime += ', '
      //   strTime += (this.textHour > 1) ? this.textHour + ' horas' : '1 hora'
      // }
      // if (this.textMinute > 0) {
      //   if (strTime !== '') strTime += ', '
      //   strTime += (this.textMinute > 1) ? this.textMinute + ' min ' + this.textSecond : '1 min ' + this.textSecond
      // }

      strTime += this.textHour < 10 ? `0${this.textHour}:` : `${this.textHour}:`
      strTime += this.textMinute < 10 ? `0${this.textMinute}:` : `${this.textMinute}:`
      strTime += this.textSecond < 10 ? `0${this.textSecond}` : this.textSecond

      return strTime
    },
    getPixList: function (val) {
      var page = val || this.currentPage
      this.$http.get('api/validations/pix-validations-list', {
        params: {
          offset: this.max * (page - 1),
          max: this.max
        }
      })
        .then(function (res) {
          this.txs = res.data
          this.total = res.data.total
          this.loading = false
          this.$root.$emit('openCollapsePix')
        })
        .catch(function (res) {
          console.error('Error')
          console.error(res)
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/variaveis.scss";
  @import "../../../assets/scss/mixins.scss";
  @import "../../../assets/scss/card.scss";
  .card-user {
    .avatar {
      width: 40px;
    }
    .card-invite-body {
      top: 102px;
    }
  }
  .img-profile {
    float: left;
    margin-right:1rem;
  }
  .validation-count {
    padding: 12px !important;
    display: flex !important;
    justify-content: space-between !important;
  }
  .bf-btn-whatsapp, .bf-btn-loadmore {
    background: #1C56E0;
    color: #FFF;
  }
  .pix-container {
    display: flex;
    align-items: center;
    width: 200px;

    .waiting-pix {
      color: #F09B1B;
      background-color: rgba(240, 155, 27, 0.2);
      font-weight: bold;
      padding: 5px 15px;
      border-radius: 5px;
    }
    .expired-pix {
      color: #BA1B22;
      background-color: #F1D1D3;
      font-weight: bold;
      padding: 5px 15px;
      border-radius: 5px;
    }
    .waiting-pix-time {
      color: #F09B1B;
      display: flex;
      flex-direction: column;
      margin-left: 3px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/partial/pix/PixListComponent.vue